import React from "react";
import { subirImagenConfiguracion, eliminarImagenConfiguracion } from "../../../../services/recetas";

const UploadImagenConfig = ({ label, urlActual, tipo, setConfig }) => {
  
  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/png"];
    if (!validTypes.includes(file.type)) {
      alert("Solo se permiten imágenes JPG o PNG.");
      return;
    }
    
    if (file.size > 10 * 1024 * 1024) {
      alert("La imagen no puede exceder 10 MB.");
      return;
    }
    
    const formData = new FormData();
    formData.append("imagen", file);
    formData.append("tipo", tipo); // 'encabezado' o 'firma'

    try {
      const response = await subirImagenConfiguracion(formData);
      setConfig((prev) => ({
        ...prev,
        [tipo === "encabezado" ? "urlImagenPersonalizada" : "urlFirmaPersonalizada"]: response.url,
      }));
    } catch (error) {
      console.error("Error subiendo imagen:", error);
      alert("Hubo un error al subir la imagen.");
    }
  };

  const handleRemoveImage = async () => {
    try {
      await eliminarImagenConfiguracion({ tipo });
      setConfig((prev) => ({
        ...prev,
        [tipo === "encabezado" ? "urlImagenPersonalizada" : "urlFirmaPersonalizada"]: "",
      }));
    } catch (error) {
      alert("Hubo un error al eliminar la imagen.");
    }
  };

  return (
    <div className="upload-imagen-config">
      <h4>{label}</h4>

      {urlActual ? (
        <>
          <img
            src={urlActual}
            alt="preview"
            style={{ width: "200px", marginBottom: "10px" }}
          />
          <br />
          <button onClick={handleRemoveImage}>Eliminar Imagen</button>
        </>
      ) : (
        <p>No hay imagen cargada, debe tener fondo blanco, configurar para personalizar</p>
      )}

      <input
        type="file"
        accept="image/png, image/jpeg"
        onChange={handleImageChange}
      />
    </div>
  );
};

export default UploadImagenConfig;
